export const MONTHS_SHORT_NAMES: { [key: string]: string } = {
  "01": "ene",
  "02": "feb",
  "03": "mar",
  "04": "abr",
  "05": "may",
  "06": "jun",
  "07": "jul",
  "08": "ago",
  "09": "sep",
  "10": "oct",
  "11": "nov",
  "12": "dic",
};

type MonthShortName = typeof MONTHS_SHORT_NAMES[keyof typeof MONTHS_SHORT_NAMES];

export const MONTHS_FULL_NAMES: { [key in MonthShortName]: string } = {
  "ene": "enero",
  "feb": "febrero",
  "mar": "marzo",
  "abr": "abril",
  "may": "mayo",
  "jun": "junio",
  "jul": "julio",
  "ago": "agosto",
  "sep": "septiembre",
  "oct": "octubre",
  "nov": "noviembre",
  "dic": "diciembre",
}
